export const toastDurations = {
  success: 4000,
  error: 6000,
};
